import { store } from "@/store/store";
import { dinamically_form } from "@/shared/dtos/dinamically_forms/dinamically_form";
import {
  VuexModule,
  Mutation,
  getModule,
  Module,
  Action,
} from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { dinamically_form_itemDto } from "@/shared/dtos/dinamically_forms/dinamically_form_itemDto";
import { form_item } from "@/shared/dtos/dinamically_forms/form_item";

@Module({
  namespaced: true,
  name: "dinamically_formModule",
  store,
  dynamic: true,
})
class dinamically_formModule extends VuexModule {
  public dinamically_forms: dinamically_form[] = [];
  public dinamically_form: dinamically_form = new dinamically_form();
  public dinamically_all_form: dinamically_form_itemDto = new dinamically_form_itemDto();

  @Action({ commit: "onGetdinamically_forms" })
  public async getdinamically_forms() {
    return await ssmHttpService.get(API.dinamically_form);
  }

  @Action({ commit: "onGetdinamically_form" })
  public async getdinamically_form(id: any) {
    return await ssmHttpService.get(API.dinamically_form + "/" + id);
  }

  @Action({ commit: "onGetdinamically_all_form" })
  public async getdinamically_all_form(id: any) {
    return await ssmHttpService.get(API.dinamically_form + "/form/" + id);
  }

  @Action
  public async guardar_modificardinamically_form(
    dinamically_form: dinamically_form_itemDto
  ) {
    return await ssmHttpService.post(
      API.dinamically_form + "/form/" + dinamically_form.dinamically_FormDto.id,
      dinamically_form.toJson()
    );
  }

  @Action
  public async guardardinamically_form(dinamically_form: dinamically_form) {
    return await ssmHttpService.post(
      API.dinamically_form,
      dinamically_form.toJson()
    );
  }

  @Action
  public async modificardinamically_form(dinamically_form: dinamically_form) {
    return await ssmHttpService.put(
      API.dinamically_form + "/" + dinamically_form.id,
      dinamically_form
    );
  }

  @Action
  public async eliminardinamically_form(dinamically_form: dinamically_form) {
    return await ssmHttpService.delete(
      API.dinamically_form + "/" + dinamically_form.id,
      null,
      false
    );
  }

  @Action({ commit: "removePantallaModoLista" })
  public eliminarPantallaModoLista(index: number) {
    return index;
  }

  @Mutation
  public removePantallaModoLista(index: number) {
    this.dinamically_all_form.form_items.splice(index, 1);
  }

  @Mutation
  public onGetdinamically_forms(res: dinamically_form[]) {
    this.dinamically_forms = res ? res.map((x) => new dinamically_form(x)) : [];
  }

  @Mutation
  public onGetdinamically_form(res: dinamically_form) {
    this.dinamically_form = new dinamically_form(res);
  }

  @Mutation
  public onGetdinamically_all_form(res: dinamically_form_itemDto) {
    this.dinamically_all_form = new dinamically_form_itemDto();
    this.dinamically_all_form.dinamically_FormDto = new dinamically_form(
      res.dinamically_FormDto
    );
    this.dinamically_all_form.form_items = res
      ? res.form_items.map((x) => new form_item(x))
      : [];

  }
}
export default getModule(dinamically_formModule);
